'use client';
import React from 'react';
var ToastContext = /*#__PURE__*/React.createContext({
  usedToaster: false
});
ToastContext.displayName = 'ToastContext';
export default ToastContext;